import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "kn-importExport kn-page" }
const _hoisted_2 = { class: "kn-page-content p-grid p-m-0" }
const _hoisted_3 = { class: "functionalities-container p-col-3 p-sm-3 p-md-2" }
const _hoisted_4 = { class: "p-col p-pt-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImportDialog = _resolveComponent("ImportDialog")
  const _component_ExportDialog = _resolveComponent("ExportDialog")
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_KnTabCard = _resolveComponent("KnTabCard")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ImportDialog, {
      visibility: _ctx.displayImportDialog,
      "onUpdate:visibility": _cache[1] || (_cache[1] = ($event: any) => (_ctx.displayImportDialog = $event))
    }, null, 8, ["visibility"]),
    _createVNode(_component_ExportDialog, {
      visibility: _ctx.displayExportDialog,
      "onUpdate:visibility": _cache[2] || (_cache[2] = ($event: any) => (_ctx.displayExportDialog = $event)),
      onExport: _ctx.startExport
    }, null, 8, ["visibility", "onExport"]),
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('importExport.title')), 1)
      ]),
      end: _withCtx(() => [
        _createVNode(_component_Button, {
          class: "kn-button p-button-text",
          onClick: _ctx.openImportDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.import')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          class: "kn-button p-button-text",
          onClick: _ctx.openExportDialog,
          disabled: _ctx.isExportDisabled()
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.export')), 1)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate",
          class: "kn-progress-bar"
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.functionalities, (functionality, index) => {
          return (_openBlock(), _createBlock(_component_KnTabCard, {
            element: functionality,
            selected: functionality.route === _ctx.$route.path,
            key: index,
            onClick: ($event: any) => (_ctx.selectType(functionality)),
            badge: _ctx.selectedItems[functionality.type].length
          }, null, 8, ["element", "selected", "onClick", "badge"]))
        }), 128))
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_router_view, {
          loading: _ctx.loading,
          "onUpdate:loading": _cache[3] || (_cache[3] = ($event: any) => (_ctx.loading = $event)),
          onOnItemSelected: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getSelectedItems($event))),
          selectedItems: _ctx.selectedItems
        }, null, 8, ["loading", "selectedItems"])
      ])
    ])
  ]))
}